import objectAssign from 'object-assign';

export function registration( state = { slides: [] }, action ) {

	var newData = {
		slides: [
			'Login',
			'Welcome',
			'WhatStage',
			'TurnoverNow',
			'TurnoverGoal',
			'StaffNow',
			'StaffGoal',
			'QuestionsIntro',
			'Clients',
			'Operations',
			'Ambition',
			'Interests',
			'AllDone'
		]
	}

	return objectAssign({}, state, newData)

}



// WEBPACK FOOTER //
// ./src/js/reducers/registration.js